module.exports = __webpack_public_path__ + "static/media/gregg-pollack.b6d61144.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/gregg-pollack.jpg
// module id = 239
// module chunks = 0